'use client';

import { Popover as BasePopover } from '@base-ui/react/popover';

import { tv } from '../../../utils/tv';

const popoverPopupArrowClasses = {
  root: 'zds-popover-popup-arrow',
} as const;

const popoverPopupArrowStyles = tv({
  slots: {
    root: [
      popoverPopupArrowClasses.root,
      'overflow-hidden',
      'data-[side=bottom]:-top-2 data-[side=bottom]:h-[9px] data-[side=bottom]:w-4',
      'data-[side=top]:-bottom-2 data-[side=top]:h-[9px] data-[side=top]:w-4',
      'data-[side=left]:-right-2 data-[side=left]:h-4 data-[side=left]:w-[9px]',
      'data-[side=right]:-left-2 data-[side=right]:h-4 data-[side=right]:w-[9px]',
    ],
    inner: [
      'absolute size-3 -translate-x-1/2 -translate-y-1/2 surface-neutral-layer-3',
      '[[data-side=bottom]_&]:top-full [[data-side=bottom]_&]:left-1/2 [[data-side=bottom]_&]:rotate-[45deg]',
      '[[data-side=top]_&]:top-0 [[data-side=top]_&]:left-1/2 [[data-side=top]_&]:rotate-[225deg]',
      '[[data-side=left]_&]:top-1/2 [[data-side=left]_&]:left-0 [[data-side=left]_&]:rotate-[135deg]',
      '[[data-side=right]_&]:top-1/2 [[data-side=right]_&]:left-full [[data-side=right]_&]:rotate-[315deg]',
    ],
  },
  variants: {
    variant: {
      outlined: { inner: 'border-t border-l border-default-muted-1' },
      elevated: {},
    },
  },
});

interface PopoverPopupArrowProps {
  variant: 'outlined' | 'elevated';
}

const PopoverPopupArrow = ({ variant }: PopoverPopupArrowProps) => {
  const styles = popoverPopupArrowStyles({ variant });

  return (
    <BasePopover.Arrow className={styles.root()}>
      <div className={styles.inner()} aria-hidden="true" />
    </BasePopover.Arrow>
  );
};

PopoverPopupArrow.displayName = 'PopoverPopupArrow';

export { PopoverPopupArrow, popoverPopupArrowClasses };
